import map from "lodash/map";
import find from "lodash/find";
import first from "lodash/first";
import React from "react";
import set from "@rill/set";
import { useTranslation } from "react-i18next";
import SupportNav from "../../../parts/support-nav";
import { useRillContext } from "../../../rill/RillReact/share/base";

const VIDEOS = [
  { titleKey: "supportVideos.welcome", id: "bqPco0e9UGc" },
  { titleKey: "supportVideos.howToBuildWorkout", id: "Y8mDUfRjano" },
  {
    titleKey: "supportVideos.creatingProgram1",
    id: "6FV9DqGWPnY",
  },
  {
    titleKey: "supportVideos.creatingProgram2",
    id: "gqZTJ_-psj0",
  },
  {
    titleKey: "supportVideos.creatingProgram3",
    id: "mdNmdOSBObE",
  },
  { titleKey: "supportVideos.moveDeleteEditCalendar", id: "clv6fWFP5MA" },
  {
    titleKey: "supportVideos.differenceStandardPremium",
    id: "NIvTvyjaH2I",
  },
  { titleKey: "supportVideos.findingPerfectProgram", id: "mPZdPRom_JU" },
  { titleKey: "supportVideos.threeTypesExercises", id: "TpfI7I96EpM" },
  { titleKey: "supportVideos.managingExerciseLibrary", id: "MqzFeF7z6YI" },
  { titleKey: "supportVideos.howToCopyWorkouts", id: "Tlp31hrY3pA" },
  {
    titleKey: "supportVideos.repMaxesPrimarySecondary",
    id: "76MfiLu1cOA",
  },
  { titleKey: "supportVideos.buildingClimbingSets", id: "ZF_wEGVDtVM" },
  { titleKey: "supportVideos.programBuilderQuickMetrics", id: "KT7I4afy0hs" },
  { titleKey: "supportVideos.welcomeToMyStrengthBook", id: "cmFvX2xDqbY" },
  { titleKey: "supportVideos.volumeAndIntensity", id: "DuIf0_Y0IrQ" },
  {
    titleKey: "supportVideos.baselineVolumeRelativeIntensity",
    id: "RCixQs9Zo4s",
  },
  {
    titleKey: "supportVideos.overUnderBaselineVolume",
    id: "VE0M8K88jw8",
  },
  { titleKey: "supportVideos.volumeSplitByCoreLift", id: "jjfWplqDHEs" },
  { titleKey: "supportVideos.personalRecordTable", id: "xEknnLP5Ns8" },
  {
    titleKey: "supportVideos.primarySecondaryVolumeSplit",
    id: "clABRxPmTVA",
  },
  { titleKey: "supportVideos.rawEquippedVolumeSplit", id: "IQQwEQj8ctw" },
  { titleKey: "supportVideos.competitionHistory", id: "WNvTFol9eNs" },
  { titleKey: "supportVideos.numberOfLifts", id: "yrNdwCXQv2Y" },
  {
    titleKey: "supportVideos.dashboardMetricsBaseline",
    id: "zZHFvhoMD1k",
  },
  {
    titleKey: "supportVideos.dashboardMetricsZone",
    id: "bgd29IZekrQ",
  },
];

function View(props) {
  const { locals } = useRillContext();
  const { t } = useTranslation("dashboard");

  const { query } = locals;
  const autoPlay = Number(Boolean(query.video));
  const activeVideo = find(VIDEOS, { id: query.video }) || first(VIDEOS);
  return (
    <div className="Main Support-Videos">
      <SupportNav />

      <div className="Content">
        <div className="Now-Playing">
          <div className="video">
            <iframe
              src={`https://www.youtube.com/embed/${activeVideo.id}?rel=0&amp;showinfo=0&amp;autoplay=${autoPlay}`}
              allowFullScreen
            ></iframe>
          </div>
          <div className="caption">
            {t("supportVideos.nowPlaying")}
            <div className="title">{t(activeVideo.titleKey)}</div>
          </div>
        </div>

        <h4>{t("supportVideos.howToVideos")}</h4>

        <div className="Videos">
          {map(VIDEOS, ({ id, titleKey }) => {
            return (
              <div key={id} className="item">
                <div
                  className="image"
                  style={{
                    backgroundImage: `url(http://img.youtube.com/vi/${id}/0.jpg)`,
                  }}
                />
                <div className="title">{t(titleKey)}</div>
                <a href={`?video=${id}`}></a>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

const Videos = (app) => {
  app.get("/videos", set("heading", ["Video Resources"]), ({ req, res }) => {
    res.body = <View />;
  });
};

export default Videos;
